( function() {
    "use strict";
    
    angular
        .module( 'ccsTrApp' )
        .factory( 'ShipmentDTOService', ShipmentDTOService );
    
    ShipmentDTOService.$inject = [ '$resource', 'DateUtils' ];
    
    function ShipmentDTOService( $resource, DateUtils ) {
        var resourceUrl = "api/shipmentDTO/:id";
        
        return $resource( resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.shipmentCreatedOn = DateUtils.convertDateTimeFromServer(data.shipmentCreatedOn);
                        data.shipmentModifiedOn = DateUtils.convertDateTimeFromServer(data.shipmentModifiedOn);
                        data.shipmentSiDate = DateUtils.convertLocalDateFromServer(data.shipmentSiDate);
                        data.shipmentOriginEta = DateUtils.convertLocalDateFromServer(data.shipmentOriginEta);
                        data.shipmentOriginEtd = DateUtils.convertLocalDateFromServer(data.shipmentOriginEtd);
                        data.shipmentDestEta = DateUtils.convertLocalDateFromServer(data.shipmentDestEta);
                        data.shipmentDestArrival = DateUtils.convertLocalDateFromServer(data.shipmentDestArrival);
                        data.shipmentBlDate = DateUtils.convertLocalDateFromServer(data.shipmentBlDate);
                        data.shipmentLcExpiry = DateUtils.convertLocalDateFromServer(data.shipmentLcExpiry);
                        data.shipmentLcLatestShipment = DateUtils.convertLocalDateFromServer(data.shipmentLcLatestShipment);
                    }
                    return data;
                }
            }
        });
    }
})();
